import * as R from 'ramda';

import sportsApi from '../../utils/sportsApi';

import { normalize, schema } from 'normalizr';

const collectionsList = new schema.Entity('collectionList', undefined, {
    // idAttribute *functions* must return the ids **value** (not key)
    idAttribute: value => value.id,
});

const getCollections = store => async (state, clientId) => {
    const userClientId = state.user.selectedUserClientId;

    // Sets Cards as loading
    const loadingState = R.assocPath(
        ['clients', userClientId, 'collections', 'list', 'isLoading'],
        true,
        state,
    );

    store.setState(loadingState);

    const apiResponse = await sportsApi
        .url(`/clients/${clientId}/collections`)
        .get()
        .json();

    const result = apiResponse.map(res => {
        if (!res.createdBy) return { ...res, creatorName: ' ' };
        const { gumgumUser, firstName, lastName } = res.createdBy;
        const creatorName = gumgumUser ? 'Relo' : `${firstName} ${lastName}`;
        return { ...res, creatorName };
    });

    const normalizedData = normalize(result, [collectionsList]);

    store.setState(
        R.assocPath(
            ['clients', userClientId, 'collections', 'list'],
            {
                isLoading: false,
                isArchiving: false,
                items: normalizedData.entities.collectionList || {},
            },
            store.getState(),
        ),
        true,
    );
};

export default getCollections;
